import { useNavigate } from "react-router-dom";
import { Heart, Home, BookOpen, Phone, Info } from "lucide-react";

const FooterQuickLinks = () => {
  const navigate = useNavigate();

  const scrollToBiodataCreator = () => {
    // Find the section by looking for the "Create Your Marriage Biodata" heading
    const biodataCreatorSection = Array.from(document.querySelectorAll('h2'))
      .find(h2 => h2.textContent?.includes('Create Your Marriage Biodata'))?.closest('section');
    if (biodataCreatorSection) {
      biodataCreatorSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        const section = Array.from(document.querySelectorAll('h2'))
          .find(h2 => h2.textContent?.includes('Create Your Marriage Biodata'))?.closest('section');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const navigateToPage = (path: string) => {
    navigate(path);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6 text-red-400">Quick Links</h3>
      <ul className="space-y-3 flex flex-col items-center sm:items-start">
        <li>
          <button 
            onClick={() => navigateToPage('/')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Home className="h-5 w-5 mr-2 text-blue-500" />
            Home
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/blog')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <BookOpen className="h-5 w-5 mr-2 text-green-500" />
            Blog
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/about')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Info className="h-5 w-5 mr-2 text-purple-500" />
            About Us
          </button>
        </li>
        <li>
          <button 
            onClick={() => navigateToPage('/contact')}
            className="text-gray-300 hover:text-white transition-colors text-lg hover:translate-x-1 transform duration-200 flex items-center"
          >
            <Phone className="h-5 w-5 mr-2 text-orange-500" />
            Contact Us
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FooterQuickLinks;
